export enum SessionStorageName {
  BROWSING_MENU = 'isBrowsingMenu',
}
